(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var accident = document.getElementById("yesAccident");
		var noaccident = document.getElementById("noAccident");
		var select = document.querySelector('select[name="ratings[accident_type]"]');

		if(accident) {
			accident.addEventListener("click", function() {
				if(this.checked) select.required = true;

				//console.log(select);
				//console.log(select.required);
			});
		}

		if(noaccident) {
			noaccident.addEventListener("click", function() {
				if(this.checked) select.required = false;

				//console.log(select);
				//console.log(select.required);
			});
		}
	});
})();

// VIN code block, submit
(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var submitBtn = document.getElementById("vin-form-btn");
		var noVinBtn = document.getElementById("vin-form-novin");
		var vinInput = document.getElementById("vin-form-input");

		// no VIN
		if(noVinBtn) {
			noVinBtn.addEventListener("click", function () {
				var noneClass = "display_none";
				var novinBlock = document.getElementById("dataVehicle");

				setTimeout(function() {
					if (novinBlock.clientHeight <= 1) {
						//console.log("none");

						submitBtn.disabled.true;
						submitBtn.setAttribute("disabled", "disabled");
						//input
						vinInput.classList.remove(noneClass);
					} else {
						//console.log("block");

						submitBtn.disabled.false;
						submitBtn.removeAttribute("disabled");
						//input
						vinInput.value = "";
						vinInput.classList.add(noneClass);
					}
				}, 1000);

			});
		}

		// "Prev" button, if first step
		var prevButton = document.querySelector(".actions a[href='#previous']");

		if(prevButton) document.addEventListener("click", function() {
			var firstStep = document.getElementById("steps-uid-0-t-0");

			if(firstStep && firstStep.parentElement) {
				if(firstStep.parentElement.classList.contains("current")) prevButton.style.display = "none";
				else prevButton.style.display = "block";
			}
		});
		
	});
})();